/**
 * Target configuration for mission FEDERER
 * Allows setting target influencers and platform
 */
import React, { useState } from 'react';
import { Box, Typography, TextField, Chip, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { colors } from '../../styles/colors';

const PLATFORM_OPTIONS = ['instagram', 'twitter', 'linkedin', 'facebook', 'youtube', 'tiktok'];

const TargetFederer = ({ config = {}, onChange, missionColor }) => {
  const [influencerInput, setInfluencerInput] = useState('');
  const influencers = config.influencers || [];
  const platform = config.platform || '';

  const handleAddInfluencer = (e) => {
    if (e.key === 'Enter' && influencerInput.trim()) {
      e.preventDefault();
      const updated = [...influencers, influencerInput.trim()];
      onChange({ ...config, mission: 'federer', influencers: updated, platform });
      setInfluencerInput('');
    }
  };

  const handleRemoveInfluencer = (idx) => {
    const updated = influencers.filter((_, i) => i !== idx);
    onChange({ ...config, mission: 'federer', influencers: updated, platform });
  };

  const handlePlatformChange = (e) => {
    onChange({ ...config, mission: 'federer', influencers, platform: e.target.value });
  };

  return (
    <Box sx={{ p: 2, borderLeft: `3px solid ${missionColor}`, borderRadius: 2, bgcolor: colors.ivory }}>
      <Typography sx={{ fontFamily: '"DM Sans", sans-serif', fontSize: '0.82rem', fontWeight: 600, color: colors.charcoal, mb: 1.5 }}>
        Ciblage Federer
      </Typography>

      <Typography sx={{ fontFamily: '"DM Sans", sans-serif', fontSize: '0.75rem', color: colors.textMed, mb: 0.5 }}>
        Influenceurs cibles (Entree pour ajouter)
      </Typography>
      <TextField
        fullWidth
        size="small"
        placeholder="Ex: @influenceur1, JournalisteName..."
        value={influencerInput}
        onChange={(e) => setInfluencerInput(e.target.value)}
        onKeyPress={handleAddInfluencer}
        sx={{ mb: 1 }}
      />
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 2 }}>
        {influencers.map((inf, idx) => (
          <Chip key={idx} label={inf} size="small" onDelete={() => handleRemoveInfluencer(idx)} sx={{ height: 24, fontSize: '0.72rem', fontFamily: '"DM Sans", sans-serif' }} />
        ))}
      </Box>

      <FormControl fullWidth size="small">
        <InputLabel>Plateforme principale</InputLabel>
        <Select value={platform} label="Plateforme principale" onChange={handlePlatformChange}>
          <MenuItem value="">Toutes</MenuItem>
          {PLATFORM_OPTIONS.map((p) => (
            <MenuItem key={p} value={p} sx={{ textTransform: 'capitalize' }}>{p}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default TargetFederer;
